// eslint-disable-next-line
import React, { useState, useEffect, useRef } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Button, message } from "antd"
import { Link } from 'react-router-dom'
import { Formik } from "formik"
import { Form, Input } from "formik-antd"
import * as yup from 'yup'
import { hideMessage, resetPassword, resetProcessStatus } from "appRedux/actions/Auth"
import { decode } from 'hi-base32'
import { EyeInvisibleOutlined, EyeTwoTone } from '@ant-design/icons'

import { AppState } from 'ReducerState'
import { isEmpty, isNil } from 'lodash'

const Activateuser = ({ history, location }: any) => {

  const params = new URLSearchParams(location.search)

  const paramsActivate: any = {
    uid: params.get('uid'),
    p: params.get("p"),
    gt: params.get("gt"),
    action: params.get("ac")
  }

  const [initialData, setInitialData] = useState<any>({ uid: undefined, gt: undefined, action: undefined })
  const [regInitialData, setRegInitialData] = useState<{ message?: string, reg: RegExp, min: number, max: number }>
    ({ message: undefined, reg: /(?=(.*\d){0})(?=(.*[a-z]){0})(?=(.*[A-Z]){0})(?=(.*[!@#$%]){0})/, min: 0, max: 20 })
  const [loader, setLoader] = useState(false)

  const { auth } = useSelector((state: AppState) => state)
  const { showMessage, alertMessage, processStatus } = auth

  const dispatch = useDispatch()
  const checkRefresh = useRef<any>(true)

  useEffect(() => {

    if (processStatus) {
      setLoader(false)
      message.success("Success.")
      dispatch(resetProcessStatus())
      setTimeout(() => { dispatch(hideMessage()) }, 100)
      setTimeout(() => { history.push('/') }, 500)
    } else if (showMessage) {
      //  message.error(alertMessage.toString())
      message.error((alertMessage as any).toString())
      setTimeout(() => { dispatch(hideMessage()) }, 100)
      setLoader(false)
    }

  }, [processStatus, dispatch, showMessage, alertMessage, history])

  useEffect(() => {
    if (checkRefresh.current) {
      const splitArray = paramsActivate.uid.split(" ")
      const fullKey = splitArray.join("+")
      setInitialData({
        uid: fullKey,
        gt: paramsActivate.gt,
        action: paramsActivate.action
      })
      const splitParameter = decode(paramsActivate.p).split("|")
      /*
      */
      const reg = new RegExp(splitParameter[1])
      setRegInitialData({ message: splitParameter[0], reg, min: parseInt(splitParameter[2]), max: parseInt(splitParameter[3]) })
      checkRefresh.current = false
    }
  }, [paramsActivate])

  const handleSubmit = (value: any) => {
    const { password, confirm } = value || {}

    if (isNil(password) || isEmpty(password)) return
    if (isNil(confirm) || isEmpty(confirm)) return

    setLoader(true)
    dispatch(resetPassword(value))
  }

  const toNullIfEmpty = (v: any, originalValue: any) => originalValue === "" ? null : v

  let schema = yup.object({
    password: yup.string().required(regInitialData.message).transform(toNullIfEmpty)
      .nullable()
      .notRequired() // ถ้า null ให้ข้ามกติกาด้านล่าง
      .matches(regInitialData.reg, regInitialData.message),
    confirm: yup.string().required(regInitialData.message).transform(toNullIfEmpty)
      .nullable().notRequired()
      .matches(regInitialData.reg, regInitialData.message).oneOf([yup.ref("password")], "Password is not match")

  }).test("both-or-none", "Password is not match", function (values: any) {
    const { password, confirm } = values as {
      password: string | null | undefined
      confirm: string | null | undefined
    }

    const bothNull = isNil(password) && isNil(confirm)
    const bothFilled = !isNil(password) && !isNil(confirm)

    if (bothNull || bothFilled) return true
    // ชี้ error ไปที่ช่องที่ยังไม่ได้กรอก
    return this.createError({
      path: (password == null) ? "password" : "confirm",
      message: (password == null) ? regInitialData.message : "Password is not match"
    })
  })

  return (
    <div className="gx-login-container">
      <div className="gx-login-content">
        <div className="gx-login-header">
          <div style={{ display: 'flex', justifyContent: 'center', marginBottom: '1rem', alignItems: "center", gap: 10 }}>
            <img
              src={require("assets/images/FROMAS_S.png")}
              alt="fromas"
              title="fromas"
              width="40"
            />
            <span style={{
              fontSize: "1.8rem",
              fontWeight: 600,
              color: '#0098ff',
              lineHeight: 1.2,
              whiteSpace: 'normal',
              display: 'flex',
              flexDirection: 'column'
            }}>
              FROMAS
            </span>
          </div>
        </div>
        <div className="gx-mb-4">
          <h2>Setup Your Password</h2>
          <p>Enter a password for your account</p>
        </div>
        <Formik
          enableReinitialize
          initialValues={initialData}
          validationSchema={schema}
          validateontouch={false}
          validateonblur={false}
          onSubmit={handleSubmit}
        >
          {({ setFieldValue, setFieldTouched }) =>
            <Form className="gx-login-form gx-form-row0" layout='vertical'>
              <Form.Item name="password" label="Password" style={{ whiteSpace: 'pre-wrap' }}>
                <Input.Password name='password'
                  type="password"
                  placeholder="Password"
                  iconRender={visible => (visible ? <EyeTwoTone /> : <EyeInvisibleOutlined />)} />
              </Form.Item>
              <Form.Item name="confirm" label={"Confirm password"} style={{ whiteSpace: 'pre-wrap' }}>
                <Input.Password name='confirm'
                  type="password"
                  placeholder="Confirm password"
                  onChange={(e: any) => {
                    if (isEmpty(e.target.value)) {
                      setFieldValue("confirm", undefined)
                      setFieldTouched("confirm", false)
                    }
                  }}
                  iconRender={visible => (visible ? <EyeTwoTone /> : <EyeInvisibleOutlined />)}
                />
              </Form.Item>
              <Input name="uid" type="hidden" />
              <Input name="action" type="hidden" />
              <Input name="gt" type="hidden" />
              <div style={{ display: 'flex', justifyContent: 'center', marginTop: 20 }}>
                <Button type="primary" htmlType="submit" loading={loader} >Submit</Button>
              </div>
            </Form>
          }
        </Formik>
      </div>
    </div>
  )

}

export default Activateuser
